export default "__VITE_ASSET__CQL5o$P0__"